var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_18275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.42681 10.0788C3.42681 10.9984 2.68351 11.7418 1.76382 11.7418C0.844137 11.7418 0.10083 10.9984 0.10083 10.0788C0.10083 9.15908 0.844137 8.41577 1.76382 8.41577H3.42681V10.0788ZM4.25831 10.0788C4.25831 9.15908 5.00162 8.41577 5.9213 8.41577C6.84099 8.41577 7.58429 9.15908 7.58429 10.0788V14.2362C7.58429 15.1559 6.84099 15.8992 5.9213 15.8992C5.00162 15.8992 4.25831 15.1559 4.25831 14.2362V10.0788Z",
    fill: "#DE235B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92121 3.40155C5.00152 3.40155 4.25821 2.65824 4.25821 1.73855C4.25821 0.818869 5.00152 0.0755615 5.92121 0.0755615C6.84089 0.0755615 7.5842 0.818869 7.5842 1.73855V3.40155H5.92121ZM5.92121 4.24564C6.84089 4.24564 7.5842 4.98895 7.5842 5.90863C7.5842 6.82832 6.84089 7.57162 5.92121 7.57162H1.75113C0.831442 7.57162 0.0881348 6.82832 0.0881348 5.90863C0.0881348 4.98895 0.831442 4.24564 1.75113 4.24564H5.92121Z",
    fill: "#3FC5EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5857 5.90863C12.5857 4.98895 13.329 4.24564 14.2487 4.24564C15.1684 4.24564 15.9117 4.98895 15.9117 5.90863C15.9117 6.82832 15.1684 7.57162 14.2487 7.57162H12.5857V5.90863ZM11.7542 5.90863C11.7542 6.82832 11.0109 7.57162 10.0912 7.57162C9.17153 7.57162 8.42822 6.82832 8.42822 5.90863V1.73855C8.42822 0.818869 9.17153 0.0755615 10.0912 0.0755615C11.0109 0.0755615 11.7542 0.818869 11.7542 1.73855V5.90863Z",
    fill: "#36B57E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0912 12.5733C11.0109 12.5733 11.7542 13.3166 11.7542 14.2362C11.7542 15.1559 11.0109 15.8992 10.0912 15.8992C9.17153 15.8992 8.42822 15.1559 8.42822 14.2362V12.5733H10.0912ZM10.0912 11.7418C9.17153 11.7418 8.42822 10.9984 8.42822 10.0788C8.42822 9.15908 9.17153 8.41577 10.0912 8.41577H14.2613C15.181 8.41577 15.9243 9.15908 15.9243 10.0788C15.9243 10.9984 15.181 11.7418 14.2613 11.7418H10.0912Z",
    fill: "#EBB13E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_18275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.5ede8d5b52437526903f3e0c63a1d49a.svg";
export { ForwardRef as ReactComponent };